<template>
  <!-- Side Sheet -->
  <transition name="sidesheet-overlay-transition">
    <!-- Virtual Overlay para el funcionamiento del close_outside, es un div que ocupa toda la pantalla-->
    <div class="ca-sidesheet-container" v-show="show_sidesheet">
      <!-- Se realiza el attach para poder fijar el dialogo a la derecha de la pantalla-->
      <v-dialog
        attach
        hide-overlay
        :value="show_sidesheet"
        :persistent="!close_outside"
        :width="width"
        :content-class="contentClass"
        transition="sidesheet-transition"
        @click:outside="clickOutside()" @keydown.esc="clickOutside()"
      >
        <v-card tile class="ca-sidesheet-card">
          <!-- Sidesheet Header (Modificable con slots "titulo" y "header-derecha") -->
          <v-app-bar flat class="ca-sidesheet-header" height="64px" :class="['ca-sidesheet-header--'+tipo]">
            <!-- Slot de titulo (Por defecto el icono y el titulo) -->
            <slot name="titulo">
              <v-icon v-if="icono_header" class="ca-sidesheet-header-icono">{{icono_header}}</v-icon>
              <v-toolbar-title>{{ titulo }}</v-toolbar-title>
            </slot>
            <v-spacer></v-spacer>
            <!-- Slot para personalizar la barra de botones que siguen al titulo -->
            <!-- Por defecto usa botones cancelar y cancelar (con variables para cambiar nombre y lanzando evento)-->
            <slot name="header-derecha" v-if="!botonera_inferior">
              <v-btn
                text
                v-if="boton_cancelar"
                class="ca-sidesheet-boton-cancelar"
                @click.native="close('cancelar')"
                :disabled="boton_cancelar_disabled"
              >{{ boton_cancelar_label }}
              </v-btn>
              <v-btn
                v-if="boton_aceptar"
                class="ca-sidesheet-boton-aceptar"
                @click.native="clickAceptar()"
                :disabled="boton_aceptar_disabled"
              >{{ boton_aceptar_label }}
              </v-btn>
            </slot>
          </v-app-bar>

          <!-- Content Sidesheet: default slot -->
          <v-card-text class="ca-sidesheet-content" :style="{'height': contentHeight}">
            <slot></slot>
            <div class="ca-sidesheet-content-loading" v-if="loading">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
          </v-card-text>

          <v-card-actions v-if="botonera_inferior">
            <slot name="footer-izquierda"></slot>
            <v-spacer></v-spacer>
            <!-- Slot para personalizar la barra de botones en el footer-->
            <!-- Por defecto usa botones cancelar y cancelar (con variables para cambiar nombre y lanzando evento)-->
            <slot name="footer-derecha">
              <v-btn
                text
                v-if="boton_cancelar"
                :height="36"
                @click.native="close('cancelar')"
                :disabled="boton_cancelar_disabled"
              >{{ boton_cancelar_label }}
              </v-btn>
              <v-btn
                text
                v-if="boton_accion"
                :height="36"
                @click.native="$emit('accion')"
                :disabled="boton_accion_disabled"
              >{{ boton_accion_label }}
              </v-btn>
              <v-btn
                v-if="boton_aceptar"
                :height="36"
                @click.native="clickAceptar()"
                :disabled="boton_aceptar_disabled"
              >{{ boton_aceptar_label }}
              </v-btn>
            </slot>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    // Variable para controlar si se muestra o no.
    // Se puede hacer sync ya que lanza update:show cuando cambia el estado
    show: {type: Boolean, default: false},
    tipo: {type: String, default: 'info'}, // Estilo de header: 'info', 'warning', 'exito','error'
    icono_header: {type: String, default: null},
    titulo: {type: String},
    boton_cancelar: {type: Boolean, default: false},
    boton_cancelar_label: {type: String, default: 'Cancelar'},
    boton_cancelar_disabled: {type: Boolean, default: false},
    boton_accion: {type: Boolean, default: false},
    boton_accion_label: {type: String, default: 'Confirmar'},
    boton_accion_disabled: {type: Boolean, default: false},
    boton_aceptar: {type: Boolean, default: false},
    boton_aceptar_label: {type: String, default: 'Aceptar'},
    boton_aceptar_disabled: {type: Boolean, default: false},
    boton_aceptar_close: {type: Boolean, default: false},
    botonera_inferior: {type: Boolean, default: false}, // Los botones aparecen en una barra inferior en vez de en el header

    // Define si el modal debe cerrarse si hace clic afuera (Si es true, se hace persistent false)
    close_outside: {type: Boolean, default: true},
    width: {default: '780px'},
    loading: {type: Boolean, default: false},
    content_class: {type: String, default: undefined}
  },
  data() {
    return {
      show_sidesheet: this.show
    };
  },
  computed: {
    contentClass() {
      let clase_base = 'ca-sidesheet';
      return this.content_class
        ? clase_base + ' ' + this.content_class
        : clase_base;
    },

    /**
       * Altura del contenido del sidesheet, total de altura de ventana menos header, y si hay barra inferior tambien.
       */
    contentHeight() {
      let altura_sin_header = window.innerHeight - 64;

      return this.botonera_inferior ? altura_sin_header - 53 : altura_sin_header;
    }
  },
  watch: {
    show(value) {
      // Sólo emito eventos si cambió valor
      if (value !== this.show_sidesheet) {
        value ? this.open() : this.close();
      }
    }
  },
  methods: {
    open() {
      this.show_sidesheet = true;
      this.$emit('update:show', true); // Evento para two-way binding de show con sync
      this.$nextTick(() => {
        document.getElementsByClassName('ca-sidesheet-content')[0].scrollTop = 0;
      });
    },

    /**
       *  Cierra el sidesheet, emite el evento que disparo el cierre si se lo especifica
       */
    close(evento = null) {
      this.show_sidesheet = false;
      if (evento) {
        this.$emit(evento);
      }
      this.$emit('close');
      this.$emit('update:show', false); // Evento para two-way binding de show con sync
    },

    /**
       *  Si esta habilitado boton_aceptar_close se cierra el sidesheet previo previamente, sino solo se emite el evento
       */
    clickAceptar() {
      this.boton_aceptar_close ? this.close('aceptar') : this.$emit('aceptar');
    },

    /**
       *  Se ejecuta cuando se clickea en el resto de la pantalla para cerrar el sidesheet si esta habilitado close_outside
       */
    clickOutside() {
      if (this.close_outside && this.show_sidesheet) {
        this.close();
      }
    }
  }
};
</script>

<style lang="scss">
  //Cubre toda la pantalla para simular el overlay con close_outside
  .ca-sidesheet-container {
    background-color: rgba(0, 0, 0, 0.46); // para que se vea como un overlay
    max-width: 100vw;
    width: 100vw;
    height: 100vh;
    z-index: 1001; //para sobrepasar el menu
    position: fixed;
    top: 0;
    left: 0;

    .v-dialog__content {
      justify-content: flex-end;
    }
    .ca-sidesheet {
      height: 100%;
      max-height: 100%;
      margin: 0;
    }
    .ca-sidesheet-card {
      height: 100%;
      flex-flow: column;
      display: flex;
    }
    .ca-sidesheet-header {
      background-color: color(celeste) !important;
      color: color(blanco);
      max-height: 64px;
      &.v-toolbar {
        box-shadow: none;
      }
      .v-toolbar__content {
        padding: 0 24px;
      }
    }
    .ca-sidesheet-header-icono {
      font-size: 32px;
      margin-right: 20px;
      color: color(blanco);
    }
    .ca-sidesheet-boton-aceptar {
      background-color: color(blanco) !important;
      color: color(naranja) !important;
    }
    .ca-sidesheet-boton-cancelar {
      color: color(blanco);
      background-color: rgba(0, 0, 0, 0.12) !important;
    }
    .ca-sidesheet-content {
      flex-grow: 1;
      padding: 0;
      overflow-y: auto;
      color: color(dark);
    }

    .v-card__actions {
      border-top: 1px solid color(gris-claro-secund);
      .v-btn {
        padding: 0 16px;
      }
    }

    .ca-sidesheet-content-loading {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 10;
      background: color(gris-claro-secund);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /** Estilo de Warning */
    .ca-sidesheet-header--warning {
      background-color: color(warning) !important;
      color: color(texto-oscuro);
      .ca-sidesheet-header-icono {
        color: color(texto-oscuro);
      }
    }

    /** Estilo de exito */
    .ca-sidesheet-header--exito {
      background-color: color(verde) !important;
      color: color(texto-oscuro);
      .ca-sidesheet-header-icono {
        color: color(texto-oscuro);
      }
    }

    /** Estilo de error */
    .ca-sidesheet-header--error {
      background-color: color(rojo) !important;
      color: color(blanco);
      .ca-sidesheet-header-icono {
        color: color(blanco);
      }
    }

    /** Fix del nuevo padding por defecto de vuetify */
    .v-dialog > .v-card > .v-card__text {
      padding: 0;
    }
  }

  /* Transiciones del Overlay */
  .sidesheet-overlay-transition-enter-active {
    transition: opacity 0.1s ease;
  }
  .sidesheet-overlay-transition-leave-active {
    transition: opacity 0.1s ease 0.2s;
  }
  .sidesheet-overlay-transition-enter,
  .sidesheet-overlay-transition-leave-to {
    opacity: 0;
  }

  //Transiciones de Sidesheet
  .sidesheet-transition-enter-active {
    transition: transform 0.3s ease-in, opacity 0.3s ease-in;
  }
  .sidesheet-transition-leave-active {
    transition: transform 0.3s ease-out, opacity 0.1s ease-out 0.2s;
  }
  .sidesheet-transition-enter,
  .sidesheet-transition-leave-to {
    transform: translateX(100%);
    opacity: 0.2;
  }
</style>
